import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { ConfigApiAccountResponse } from '../types/account'

type Props = {
  userUniqueId: string
  companyId?: string
}

/**
 * Fetches basic company settings.
 */
export function useQueryAccount({ userUniqueId, companyId }: Props) {
  return useQuery<ConfigApiAccountResponse>({
    queryKey: ['config.user', userUniqueId, companyId ?? null],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/config-api/user`, {
        params: companyId ? { companyId } : undefined,
      })

      return data
    },
    staleTime: MINUTE_IN_MS * 5, // cache for 5 minutes
  })
}
